import { getTestId } from '@airtel/air-design-system';
var data = [{
  label: 'Long icon button label',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {
    id: 'prepaid'
  }
}, {
  label: 'Postpaid',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {
    id: 'postpaid'
  }
}, {
  label: 'DTH',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {
    id: 'dth'
  }
}, {
  label: 'Fiber',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {
    id: 'fiber'
  }
}, {
  label: 'Gas',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {
    id: 'gas'
  }
}, {
  label: 'Electricity',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {
    id: 'electricity'
  }
}, {
  label: 'Water',
  iconName: 'PrepaidIcon',
  type: 'secondary',
  onPress: {
    id: 'water'
  }
}, {
  label: 'View More',
  iconName: 'DownChevronIcon',
  type: 'primary',
  onPress: {
    id: 'view-more'
  }
}];
export var defaultProps = Object.assign({
  data,
  heading: 'Heading for the card',
  ctaAction: {
    iconName: 'RightChevronIcon'
  },
  useNewStyle: false,
  itemsToBeShownInRow: 4
}, getTestId('QuickActionsCardWidgetContainer'));